import React, { Component } from 'react'
import PlusButton from 'components/button/plus-button'
import { emailIsValid } from 'utils'

export default class InputStandard extends Component {
	handleChange = e => {
		const {
			onChange,
			value
		} = this.props

		const oldValue = value
		const newValue = e.target.value

		if(newValue && oldValue && newValue.length > oldValue.length){
			if(newValue.length > 120){
				return
			}
		}

		onChange(e)
	}

	render() {
		const {
			callback,
			value,
			placeholder,
			outlineOnFocus,
			showPlus,
			validate,
			focusCallback,
			blurCallback,
			isSearch,
			disabled,
			onPaste,
			innerRef,
			type = 'text'
		} = this.props

		let containerClassName = 'input-standard-wrap '

		if(isSearch){
			containerClassName += 'is-search'
		}

		if(disabled){
			containerClassName += ' disabled'
		}

		let inputClassName = ' input-standard'

		if(outlineOnFocus){
			inputClassName += ' focus-outline'
		}

		let isValid = true

		if(!value){
			isValid = false
		}

		if(validate){
			switch(validate){
				case 'email':
					isValid = emailIsValid(value)
					break
			}
		}

		return (
			<div className={containerClassName}>
				{ disabled ? 
					<span>
						{ value }
					</span>
				:
					<input 
						onFocus={_ => {
							focusCallback && focusCallback()}
						} 
						onBlur={_ => {
							blurCallback && blurCallback()}
						} 
						onPaste={e => {
							onPaste && onPaste(e)
						}}
						onKeyPress={e => {
							(e.key === 'Enter' && callback && isValid && callback() )}
						} 
						ref={ref => {
							if(innerRef){
								innerRef(ref)
							}

							this.inputRef = ref
						}}
						value={value} 
						onChange={this.handleChange} 
						className={inputClassName} 
						type={type}
						placeholder={placeholder} 
					/>
				}
				{ showPlus && 
					<PlusButton callback={callback} disabled={!isValid} />
				}
			</div>
		)
	}
}
